/*
 * @Author: panweikang
 * @Date: 2024-01-03 16:57:12
 * @LastEditTime: 2024-07-24 09:42:33
 * @Description:
 */
import React, { useEffect, useState } from 'react'
import './detail.scss'
import logo from '../../static/report/logo.png'

import myReportPng from '../../static/report/myReport.png'
import myReportNewPng from '../../static/report/myReportNew.png'
import { Button, Swiper, CenterPopup, Toast, Image } from 'antd-mobile'
import { useNavigate, useParams } from 'react-router-dom'
import {
  deductArmouryNumberApi,
  sendEmailByReportApi,
  checkUserViewReportApi,
  checkArmouryNumberApi,
} from '../../api/yearEndReportApi'

import EMailModal from '../../components/MEmail/index'
import { detailImage } from './constants'
import wxConfig from '../../utils/wxConfig'
import MHead from '../../components/MHead/index'

const DetailPage = () => {
  // document.title = '2023下半年度高标仓市场'
  document.title = '瑞莱博2024年物流地产年度报告'
  const { id } = useParams()
  const [loaded, setLoaded] = useState(false)
  let userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}')

  useEffect(() => {
    // wxConfig()
    if (id === 'lastYear') {
      setLoaded(true)
    } else {
      getDetail()
    }
  }, [])

  let getDetail = async () => {
    debugger
    let res = await checkUserViewReportApi({
      topicId: id,
      openId: userInfo.openId,
    })

    if (res.data.isPay) {
      // 购买过了 直接展示
      setLoaded(true)
    } else {
      // 没购买 扣费成功后展示
      let res1 = await deductArmouryNumberApi({
        openId: userInfo.openId,
        topicId: id,
      })
      if (res1.status === 200) {
        setLoaded(true)
      } else {
        Toast.show(res1.msg)
      }
    }
  }

  let navigate = useNavigate()

  let [visible, setVisible] = useState(false)

  let send = async (email) => {
    let params = {
      openId: userInfo.openId,
      email,
    }
    if (id === 'lastYear') {
      params.type = 1
    } else {
      params.topicId = id
      params.type = 0
    }

    let res = await sendEmailByReportApi(params)
    Toast.show(res.msg)
    setVisible(false)
  }
  let goMineReport = () => {
    navigate('/rlb/YearEndReport/mineReport')
  }
  let goMore = async () => {
    let res = await checkArmouryNumberApi({
      openId: userInfo.openId,
    })
    if (res.data >= 1) {
      // 有锦囊 跳大区
      navigate(`/rlb/YearMiddleReport2024/1`)
    } else {
      // 没有锦囊 跳支付
      navigate('/rlb/YearEndReport/pay')
    }
  }

  let goHome = () => {
    navigate(`/rlb/YearMiddleReport2024/1`)
  }
  let [slideButtonVisible, setslideButtonVisible] = useState(true)
  let onIndexChange = (index) => {
    setslideButtonVisible(index + 1 < detailImage[id].length)
  }

  if (loaded) {
    return (
      <>
        <div className="yearEndReportDetail page">
          <MHead />
          <div className="pageContent">
            <Swiper
              direction="vertical"
              onIndexChange={onIndexChange}
              indicator={(total, current) => (
                <div className="customIndicator">{`${current + 1} / ${total}`}</div>
              )}
            >
              {detailImage[id].map((item, index) => {
                return (
                  <Swiper.Item key={index}>
                    {/* <img src={item} alt={index} /> */}
                    <Image
                      fit="contain"
                      src={item}
                      placeholder={<div className="imgLoading">图片加载中...</div>}
                    />
                  </Swiper.Item>
                )
              })}
            </Swiper>
            {slideButtonVisible && (
              <div className="slideButton">
                <p>向下滑</p>
                <svg
                  t="1705324419065"
                  className="iconSlideButton"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="4609"
                  width="20"
                  height="20"
                >
                  <path
                    d="M792.5 446.6L512 727.1 231.5 446.6c-11.7-11.7-30.7-11.7-42.4 0s-11.7 30.7 0 42.4l301.8 301.7c5.9 5.9 13.5 8.8 21.2 8.8 7.7 0 15.4-2.9 21.2-8.8L835 489c11.7-11.7 11.7-30.7 0-42.4-11.8-11.7-30.8-11.7-42.5 0zM490.8 577.4c5.9 5.9 13.5 8.8 21.2 8.8 7.7 0 15.4-2.9 21.2-8.8L835 275.7c11.7-11.7 11.7-30.7 0-42.4s-30.7-11.7-42.4 0L512 513.8 231.5 233.3c-11.7-11.7-30.7-11.7-42.4 0s-11.7 30.7 0 42.4l301.7 301.7z"
                    fill="#444444"
                    p-id="4610"
                  ></path>
                </svg>
              </div>
            )}
          </div>
          <div className="pageFooter">
            <Button
              className="btn"
              color="primary"
              fill="outline"
              onClick={() => {
                setVisible(true)
              }}
            >
              下载报告
            </Button>
            <Button className="btn" color="primary" onClick={goMore}>
              查看更多报告
            </Button>
          </div>

          {/* <MFooter /> */}
          <img
            className="myReport"
            src={myReportNewPng}
            alt="myReportNewPng"
            onClick={goMineReport}
          />
        </div>
        <EMailModal okText='确认发送' visible={visible} setVisible={setVisible} send={send} />
      </>
    )
  } else {
    return <></>
  }
}

export default DetailPage
